import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Icons from "../Constants/Icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Faq = () => {
  const { t } = useTranslation();
  const hostName  = window.location.hostname

  const [searchTerm, setSearchTerm] = useState("");
  const faqs = [
    {
      category: t("1. Property Management"),
      items: [
        {
          question: t("What do your services cover?"),
          answer: t(
            "Our professional cleaning team is available 365 days a year, offering 5-star hotel-grade cleaning services."
          ),
        },
        {
          question: t("What is your experience?"),
          answer: t(
            "Over the past 6 years, we have built a diversified portfolio of over $20,000,000 worth of properties, generating millions of dollars in revenue under our management."
          ),
        },
        {
          question: t("How do you filter guests?"),
          answer: t("Yes! We require:"),
          typeof: "typeof",
        },
        {
          question: t("How does it work with cleaning fees?"),
          answer: t("We always charge the guest for the cleaning fees."),
        },
        {
          question: t("What if we need a handyman?"),
          answer: t(
            "Over the past 6 years, we have built a great network of professionals. If needed, we will coordinate everything for you, and they will invoice you directly for full transparency."
          ),
        },
        {
          question: t("How do you create the Airbnb listing?"),
          answer: t(
            "With our experience, we create the most attractive listing with captivating photos, descriptions, titles, and overall aesthetics."
          ),
        },
      ],
    },
    {
      category: t("2. Financial & Contractual Details"),
      items: [
        {
          question: t("How will I get paid?"),
          answer: t(
            "We will add you as a payee on Airbnb, and you’ll receive a payout 24 hours after the guest checks in, directly from Airbnb."
          ),
        },
        {
          question: t("How does it work for damages?"),
          answer: t(
            "We handle all claims for you on Airbnb with our $1,000,000 Superhost insurance for each booking. Airbnb also offers a great Superhost program called Air Cover."
          ),
        },
        {
          question: t("What happens if we ever want to stop the engagement?"),
          answer: t(
            "We offer all clients an open-ended contract, meaning you can stop whenever you like, with no penalties."
          ),
        },
        {
          question: t("What are your rates?"),
          answer: t(
            "Rates vary depending on the type and size of your property. Please call or text us for more details."
          ),
        },
        {
          question: t("How do you optimize pricing?"),
          answer: t(
            "By analyzing the rental activity of comparable properties, we customize the nightly rates to maximize your monthly revenues and occupancy rate."
          ),
        },
        {
          question: t("How can I contact you?"),
          answer: t("24/7 Support"),
          answer1: t("Customer Service | KŌZĒ"),
          answer2: t("CustomerService@kozechalets.ca"),
          answer3: t("+1 (310) 708 3969"),
        },
      ],
    },
    {
      category: t("3. Property Usage & Access"),
      items: [
        {
          question: t("What if I want to use the property for myself?"),
          answer: t(
            "Whenever you want to use it, just let us know, and we'll block the dates for you - no charge, of course."
          ),
        },
        {
          question: t("What access will I have?"),
          answer: t(
            "We add all our clients as co-hosts on Airbnb. You’ll have full access to reservations, pricing, transaction history, and calendar availability."
          ),
        },
        {
          question: t(
            "What if we bring a client who is interested in renting our chalet at a time that it is not already rented (not family and friends)?"
          ),
          answer: t(
            "It would be best to direct them to the Airbnb listing to build the reviews, be covered by Airbnb’s $1,000,000 insurance, and undergo rigorous KYC (Know Your Customer) checks."
          ),
        },
        {
          question: t("How does your customer service work?"),
          answer: t(
            "Our team is available to answer any questions or inquiries at all times."
          ),
        },
        {
          question: t("How do you handle inventory reporting?"),
          answer: t(
            "We will alert you when inventory is low (soap, toilet paper, etc.)."
          ),
        },
        {
          question: t("How do you report damages?"),
          answer: t(
            "In the rare case of damage from a guest, we handle the claims on your behalf with Airbnb’s Air Cover $1,000,000 insurance."
          ),
        },
      ],
    },
  ];

  const Guestfaqs = [
    {

      category: t("1. Check-In/Out and Parking"),
      items: [
        {
          question: t("How does the check-in process work?"),
          answer: t(
            "We offer self-check-in using a secure code, which will be sent to you at 3 PM on the day of your check-in."
          ),
        },
        {
          question: t("What time is check-in?"),
          answer: t(
            "You can check in any time after 4:00 PM."
          ),
        },
        {
          question: t("What time do we need to check out by?"),
          answer: t(
            "Check-out is any time before 11:00 AM."
          ),
        },
        {
          question: t("Is early check-in or late check-out available?"),
          answer: t(
            "Please message us on the day of your check-in/check-out to confirm availability. If possible, we’d be happy to offer it."
          ),
        },
        {
          question: t("Can we park before check-in or after check-out?"),
          answer: t(
            "Unfortunately, no. Our cleaning team needs access to the parking spots. However, if the unit is ready before check-in, we will notify you."
          ),
        },

      ],
    },

    {

      category: t("2. Policies and Property Rules"),
      items: [
        {
          question: t("Can we smoke or have a party at the property?"),
          answer: t(
            "We have a strict no-party policy and no smoking allowed indoors. You may smoke outside, but it must be at least 8 meters away from any door or window. Please dispose of cigarette butts properly. Penalty fees will apply if cigarettes are found on the property."
          ),
        },
        {
          question: t("Can we have visitors during our stay?"),
          answer: t(
            "The property has a strict capacity limit, so no visitors are allowed during the day or overnight. If the capacity is exceeded, penalties may apply."
          ),
        },
        {
          question: t("Can I cancel my reservation and get a refund?"),
          answer: t(
            "Cancellations are handled through the platform you reserved on. Please contact them directly for any refund requests, as we cannot manage refunds on our end."
          ),
        },
        {
          question: t("Are pets allowed?"),
          answer: t(
            "Unfortunately, we have a strict no-pets policy due to allergy concerns."
          ),
        },
        {
          question: t("Is there a minimum or maximum stay length?"),
          answer: t(
            "The minimum stay is 2 nights, but there is no maximum."
          ),
        },

      ],
    },
    {
      category: t("3. Amenities and Housekeeping"),
      items: [
        {
          question: t("What should I do if the WiFi isn’t working?"),
          answer: t(
            "Please unplug the router, wait 1 minute, then plug it back in. If this doesn’t fix the issue, feel free to message us for further assistance."
          ),
        },
        {
          question: t("What should we do with the towels and linens when checking out?"),
          answer: t(
            "Please leave the beds unmade, and place used towels in the bathtub."
          ),
        },
        {
          question: t("Where should we put our garbage?"),
          answer: t(
            "Please place your garbage in the outdoor bins located near the property."
          ),
        },
        {
          question: t("Do you have other listings we can see?"),
          answer: t(
            "Yes! You can check out our other listings on our Airbnb profile:"
          ),
        },


      ]
    }

  ]
  const filteredFAQs = faqs
    .map((category) => ({
      ...category,
      items: category.items.filter((item) =>
        item.question.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    }))
    .filter((category) => category.items.length > 0);
  const [activeIndex, setActiveIndex] = useState({
    categoryIndex: null,
    itemIndex: null,
  });

  const [activeHostIndex, setActiveHostIndex] = useState({
    categoryHostIndex: null,
    itemHostIndex: null,
  });

  const toggleHostAnswer = (categoryHostIndex, itemHostIndex) => {
    setActiveHostIndex((prevState) =>
      prevState.categoryHostIndex === categoryHostIndex &&
        prevState.itemHostIndex === itemHostIndex
        ? { categoryHostIndex: null, itemHostIndex: null }
        : { categoryHostIndex, itemHostIndex }
    );
  };

  const toggleAnswer = (categoryIndex, itemIndex) => {
    setActiveIndex((prevState) =>
      prevState.categoryIndex === categoryIndex &&
        prevState.itemIndex === itemIndex
        ? { categoryIndex: null, itemIndex: null }
        : { categoryIndex, itemIndex }
    );
  };

  return (
    <div style={{ backgroundColor: "#E0C9AA" }} className="pt-32 pb-32 max-[767px]:pt-12">
      <div className="container">
        <div className="text-center font-48 cinzel relative mb-10">
          {t("Frequently Asked Questions")}
        </div>
        <div className="text-left font-48 cinzel mt-20 relative max-[767px]:mt-12">
          {t("How can we assist you today?")}
        </div>

        <div className="w-full font-24 border px-5 my-6 border-black flex items-center">
          <img
            src={Icons.Search}
            className="w-10 h-10 object-cover"
            alt="Search Icon"
          />
          <input
            type="text"
            className="bg-transparent py-4 px-5 placeholder:text-[#5E5D5D]"
            placeholder={t("Search for topics…")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            aria-label={t("Search FAQs")}
          />
        </div>
        <div className="text-center font-48 cinzel mt-16 relative">
          {t("FAQs - Property Owners")}
        </div>
        <div className="flex gap-8 mt-10 flex-wrap justify-between">
          {filteredFAQs.map((category, categoryIndex) => (
            <div
              key={categoryIndex}
              className="border border-black px-5 pb-5 w-[31%] max-[954px]:w-[45%] max-[666px]:w-[100%]"
            >
              <div className="font-48 Optima  mt-8">
                {category.category}
              </div>
              <ul
                className="mt-8 ml-5 grid gap-3"
                style={{ listStyle: "none" }}
              >
                {category.items.map((item, itemIndex) => (
                  <React.Fragment key={itemIndex}>
                    <li
                      onClick={() => toggleAnswer(categoryIndex, itemIndex)}
                      style={{ display: "flex" }}
                      className={`Optima collapse_txte font-24 font-semibold cursor-pointer flex gap-2 ${activeIndex.categoryIndex === categoryIndex &&
                        activeIndex.itemIndex === itemIndex
                        ? "active_faq"
                        : ""
                        }`}
                    >
                      <span
                        className="font-semibold mr-3 plash block"
                        style={{ width: "25px" }}
                      >
                        <img
                          className="downArrowIcon"
                          alt=""
                          src={Icons.Arror}
                          style={{ width: "15px" }}
                        />
                      </span>
                      <span
                        className="font-semibold mr-3 maines block"
                        style={{ width: "25px" }}
                      >
                        <img
                          className="downArrowIcon"
                          alt=""
                          src={Icons.Arror}
                          style={{ width: "15px", rotate: "180deg" }}
                        />
                      </span>
                      <div style={{ width: "97%" }}>{item.question}</div>
                    </li>
                    {activeIndex.categoryIndex === categoryIndex &&
                      activeIndex.itemIndex === itemIndex && (
                        <>
                          <p className="Optima font-24">{item.answer}</p>
                          {item?.answer1 && (
                            <p className="Optima font-24">{item?.answer1}</p>
                          )}
                          {item?.answer2 && (
                            <p className="Optima font-24">{item?.answer2}</p>
                          )}
                          {item?.answer3 && (
                            <p className="Optima font-24">{item?.answer3}</p>
                          )}
                          {item.typeof === "typeof" && (
                            <div>
                              {[
                                t("Official Government ID(s)"),
                                t("Recommendations from past hosts"),
                                t("Verified by Airbnb"),
                                t("A security deposit"),
                              ].map((text, idx) => (
                                <p key={idx} className="Optima font-24">
                                  <FontAwesomeIcon
                                    className="mr-2"
                                    icon={faArrowRight}
                                  />
                                  {text}
                                </p>
                              ))}
                            </div>
                          )}
                        </>
                      )}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="text-center font-48 cinzel mt-16 relative">
          {t("FAQs - Guests")}
        </div>
        <div className="flex gap-8 mt-10 flex-wrap justify-between">

          {Guestfaqs.map((category, categoryHostIndex) => (

            <div
              key={categoryHostIndex}
              className="border border-black px-5 pb-5 w-[31%] max-[954px]:w-[45%] max-[666px]:w-[100%]"
            >
              <div className="font-48 Optima  mt-8">
                {category.category}
              </div>
              <ul className="mt-7 ml-5  gap-1" style={{ listStyle: "none" }}>
                {category.items.map((item, itemHostIndex) => (
                  <React.Fragment key={itemHostIndex}>
                    <li
                      onClick={() =>
                        toggleHostAnswer(categoryHostIndex, itemHostIndex)
                      }
                      style={{ listStyle: "none" }}
                      className={`Optima collapse_txte font-24 font-semibold cursor-pointer mt-5 max-[767px]:mt-1 ml-0 flex  gap-1 ${activeHostIndex.categoryHostIndex ===
                        categoryHostIndex &&
                        activeHostIndex.itemHostIndex === itemHostIndex
                        ? "active_faq"
                        : ""
                        }`}
                    >
                      <span
                        className="font-semibold mr-3 plash block"
                        style={{ width: "25px" }}
                      >
                        <img
                          className="downArrowIcon"
                          alt=""
                          src={Icons.Arror}
                          style={{ width: "15px" }}
                        />
                      </span>
                      <span
                        className="font-semibold mr-3 maines block"
                        style={{ width: "25px" }}
                      >
                        <img
                          className="downArrowIcon"
                          alt=""
                          src={Icons.Arror}
                          style={{ width: "15px", rotate: "180deg" }}
                        />
                      </span>
                      <div style={{ width: "100%" }}>{item.question}</div>
                    </li>
                    {categoryHostIndex == 11 &&
                      activeHostIndex.categoryHostIndex === categoryHostIndex &&
                      activeHostIndex.itemHostIndex === itemHostIndex ? (
                      <div
                        style={{ display: "flex", marginTop: "5px" }}
                        className={`Optima  flex gap-2`}
                      >
                        <span
                          className=" mr-3 plash block"
                          style={{ width: "25px" }}
                        ></span>
                        <p style={{ width: "100%" }} className="Optima font-24">
                          {item.answer}
                          <a
                            href= {hostName.includes("kozechalets")  ? "https://reservations.kozechalets.ca/?lang=en" : "https://reservations.kozestays.com/?lang=en"}
                            target="_blank"
                            style={{
                              color: "black",
                              paddingLeft: '5px',
                              textDecoration: "underline",
                            }}
                          >
                            {t("Click Here")}
                          </a>
                        </p>
                      </div>
                    ) : (
                      activeHostIndex.categoryHostIndex === categoryHostIndex &&
                      activeHostIndex.itemHostIndex === itemHostIndex && (
                        <div
                          style={{ display: "flex", marginTop: "5px" }}
                          className={`Optima  flex gap-2`}
                        >
                          <span
                            className="font-semibold mr-3 plash block"
                            style={{ width: "25px" }}
                          ></span>
                          <p
                            style={{ width: "100%" }}
                            className="Optima font-24"
                          >
                            {item.answer}
                            {item.answer === "Yes! You can check out our other listings on our Airbnb profile:" &&
                              <a
                                href="https://www.airbnb.co.in/users/show/57441707"
                                target="_blank"
                                style={{
                                  color: "black",
                                  paddingLeft: '5px',
                                  textDecoration: "underline",
                                }}
                              >
                                {t("Click Here")}
                              </a>}
                          </p>
                        </div>
                      )
                    )}
                  </React.Fragment>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="Optima collapse_txte font-24 font-semibold mt-10">
          {t("Not what you are looking for? Feel free to")}{" "}
          <Link
            className=" decoration-black"
            style={{ textDecoration: "underline" }}
            to="/ContactUs"
          >
            {t("Contact us.")}
            <FontAwesomeIcon icon={faArrowRight} style={{ rotate: "-30deg" }} />
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Faq;
